import {
  CreatePCRModel,
  FileParameter,
  FindPCRsModel,
  GeographicalScopesClient,
  PCRClient,
  PCRStatusSelection,
  ProductCategoriesClient,
  ProgramOperatorsClient,
  UpdatePCRPropertyModel,
} from './EpdClient';

const client = new PCRClient(process.env.REACT_APP_API_URL);
const productCategoryClient = new ProductCategoriesClient(process.env.REACT_APP_API_URL);
const geographicalClient = new GeographicalScopesClient(process.env.REACT_APP_API_URL);
const programOperatorsClient = new ProgramOperatorsClient(process.env.REACT_APP_API_URL);

class PcrService {
  static findPcr = async (query: Omit<FindPCRsModel, 'pcrStatusSelection'>) => {
    return await client.getAll({
      ...query,
      pcrStatusSelection: PCRStatusSelection.Registered,
    });
  };

  static getAllCategories = async () => {
    return await productCategoryClient.getAll('', false);
  };

  static getRootCategories = async () => {
    return await productCategoryClient.getRoot();
  };

  static getNonRootCategories = async () => {
    return await productCategoryClient.getNonRoot();
  };

  static getGeographicals = async () => {
    return await geographicalClient.getAll(null);
  };

  static createPcr = async () => {
    const newPcr: CreatePCRModel = {};
    const result = await client.create(newPcr);
    return result;
  };

  static updateProperty = async (pcrId: string, propertyName: string, newValue: any) => {
    const updatePcr: UpdatePCRPropertyModel = { pcrId, propertyName, newValue };
    const result = await client.updatePCRProperty(updatePcr);
    return result;
  };

  static addPcrFile = async (pcrId: string, propertyName: string, fileName: string, data: any) => {
    const addFile: FileParameter = { fileName, data };
    const result = await client.addPCRFile(pcrId, propertyName, addFile);
    return result;
  };

  static removePcrFile = async (pcrId: string, fileId: string) => {
    const result = await client.removePCRFile(pcrId, fileId);
    return result;
  };

  static getProgramOperators = async (filter?: string) => {
    const result = await programOperatorsClient.getAll(filter);
    return result;
  };
}

export default PcrService;
